/**
 * Public portal base URL for ticket links (reply templates, Share, etc.).
 *
 * Production: set REACT_APP_PUBLIC_URL in .env.production before `npm run build`
 * Backend emails: set FRONTEND_URL in backend/.env.production (same value)
 */
export function getPublicAppUrl() {
  const configured = (process.env.REACT_APP_PUBLIC_URL || '').trim().replace(/\/$/, '');
  if (configured) return configured;
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return '';
}

export function buildTicketUrl(ticketIdOrNumber) {
  const id = String(ticketIdOrNumber || '').trim();
  if (!id) return getPublicAppUrl();
  return `${getPublicAppUrl()}/tickets/${encodeURIComponent(id)}`;
}
